import { StarIcon } from '@chakra-ui/icons';
import { Box, Center, Flex, Text, Image } from '@chakra-ui/react';
import { sampleHotels } from 'data';
import { Price } from 'hooks';
import { AiOutlineHeart } from 'react-icons/ai';

type ExperiencesBoxProps = {
  data: {
    image: string;
    isFavorite: boolean;
    activityName: string;
    starRating: string;
    price: Price;
  };
};

const ExperiencesBox = ({ data }: ExperiencesBoxProps) => {
  return (
      <Box>
        <Box width={300} height={200} position='relative'>
          <Image borderRadius={22} src={data.image || sampleHotels[0].image} />
          <Center backgroundColor='#FBFBFB' position='absolute' top={4} right={4} padding={3} borderRadius={'full'}>
            <AiOutlineHeart color='#6F6F6F' size={18} />
          </Center>
        </Box>
        <Box>
          <Flex alignItems='center' paddingTop='10px'>
            <Text color='primary.black' fontSize='17px' fontWeight={700}>
             <StarIcon /> {data.starRating}
            </Text>
          </Flex>
          <Flex paddingTop='11px'>
            <Text fontSize='lg' color='primary.black' fontWeight={400}>
              {data.activityName}
            </Text>
          </Flex>
          <Flex paddingTop='5px'>
            <Text color='primary.black' fontSize='md' fontWeight={700} paddingRight={1}>
             {`From ${data.price?.net || ''} $`}
            </Text>
            <Text color='primary.black' fontSize='md' fontWeight={400}>
               person
            </Text>
          </Flex>
        </Box>
      </Box>
  );
};

export { ExperiencesBox };
